import * as React from "react"
import EventMap from "@components/EventMap"
import { GoogleMapsWrapper } from "@components/EventMap/styles"
import { FC } from "react"

const StrapiVideo: FC<{location: Location}> = ({ location }) => {
    return <EventMap
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_MAPS_KEY}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div style={{ height: "100%" }} />}
        containerElement={<GoogleMapsWrapper />}
        mapElement={<div style={{ height: "100%" }} />}
        location={location}
    />
}

export default StrapiVideo
